/**
 * Shared error-body shape for `/api/v1/**`.
 *
 * Measured, not assumed: of the 585 error responses under `apps/api/app`, 475
 * emit `{ error: <machine code> }`. Two documented exceptions exist —
 * vine validation failures emit `{ errors: [...] }` (vine's own shape, not
 * ours), and a few endpoints add a field alongside `error` (e.g.
 * `{ error, field }` from invoice-settings validation).
 *
 * Kept CLOSED rather than given an index signature: an open shape would switch
 * off excess-property checking, which is the only thing that catches a typo'd
 * error key at a mock site. Endpoints carrying extras declare them explicitly,
 * e.g. `ApiErrorBody & { field: string }`.
 */
export interface ApiErrorBody {
  /** Machine-readable code the client switches on, e.g. `'seat_limit_reached'`. */
  error: string
}

/**
 * The caller's seat in the named team workspace is disabled. The workspace is
 * still theirs (it stays in the switcher), but its content cannot be read and
 * no new work can start there. Sent as HTTP 403 `{ error }` and as the voice
 * relay's error-frame `code`.
 *
 * Unlike `active_context_forbidden`, a client must NOT clear the selected
 * workspace, retry in another one, fall back to another transport, or sign
 * the user out on this code.
 */
export const TEAM_MEMBER_DISABLED_ERROR = 'team_member_disabled'
export type TeamMemberDisabledErrorCode = typeof TEAM_MEMBER_DISABLED_ERROR
